import { useState, useRef } from "react";
import { Wrapper as PopperWrapper } from "../../Popper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
    faCircleXmark,
    faMagnifyingGlass,
    faSpinner,
    faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import HeadlessTippy from "@tippyjs/react/headless";
import SearchCar from "~/components/Popper/SearchCar";
import styles from "./Search.module.scss";
import classNames from "classnames/bind";
import useDebounce from "~/hooks/useDebounce";
const cx = classNames.bind(styles);
const Search = () => {
    const [searchValue, setSearchValue] = useState("");
    const [showResult, setShowResult] = useState(true);
    const [path, setPath] = useState("");
    const debounce = useDebounce(searchValue, 300);
    const inputRef = useRef();
    const searchRef = useRef();
    const modalRef = useRef();
    const conutlRef = useRef();
    const handleHideResult = () => {
        setShowResult(false);
    };

    const handleClear = () => {
        setSearchValue("");
        inputRef.current.focus();
    };

    const handleShowSearch = () => {
        searchRef.current.style.display = "flex";
        modalRef.current.style.height = "100vh";
        modalRef.current.style.zIndex = "1";
        modalRef.current.style.display = "block";

        inputRef.current.focus();
    };
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    const handleClickBlur = () => {
        if (!mediaQuery) {
            searchRef.current.style.display = "none";
        }
        modalRef.current.style.height = "0vh";
        modalRef.current.style.zIndex = "-1";
        modalRef.current.style.display = "none";
        setShowResult(false);
    };
    const handleResult = (count, pathName, car) => {
        if (conutlRef.current && count > 1) {
            conutlRef.current.innerText = `Xem ${count} kết quả`;
            setPath(pathName);
        } else if (conutlRef.current && count === 0) {
            conutlRef.current.innerText = ``;
        } else if (conutlRef.current) {
            conutlRef.current.innerText = `${count}`;
            setPath("");
        }
    };
    return (
        <>
            {" "}
            <span>
                <HeadlessTippy
                    visible={showResult && debounce.trim().length > 0}
                    interactive
                    placement="bottom"
                    render={(attrs) => (
                        <div
                            className={cx("search_result")}
                            tabIndex="-1"
                            {...attrs}
                        >
                            <PopperWrapper>
                                <h4 className={cx("search_title")}>
                                    <span> Siêu xe</span>{" "}
                                    <span>
                                        <Link
                                            to={path !== "" && path}
                                            ref={conutlRef}
                                        ></Link>{" "}
                                        <i>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                            />
                                        </i>
                                    </span>
                                </h4>
                                <SearchCar
                                    value={debounce}
                                    onResult={handleResult}
                                    onBlur={handleClickBlur}
                                />
                            </PopperWrapper>
                        </div>
                    )}
                    onClickOutside={handleHideResult}
                >
                    <div
                        ref={searchRef}
                        className={cx("search_wrap", "mobile")}
                    >
                        <input
                            ref={inputRef}
                            value={searchValue}
                            placeholder="Bạn muốn xem chiếc siêu xe nào ?"
                            spellCheck={false}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onFocus={() => setShowResult(true)}
                        />
                        <button className={cx("clear")}>
                            <FontAwesomeIcon
                                icon={faCircleXmark}
                                onClick={handleClear}
                            />
                        </button>
                        <FontAwesomeIcon
                            className={cx("loading")}
                            icon={faSpinner}
                        />

                        <button className={cx("search_btn")}>
                            <FontAwesomeIcon
                                className={cx("search_btn-icon")}
                                icon={faMagnifyingGlass}
                            />
                        </button>
                    </div>
                </HeadlessTippy>
            </span>
            <span onClick={handleShowSearch} className="find">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
            </span>
            <div
                ref={modalRef}
                onClick={handleClickBlur}
                className={cx("modal")}
            >
                <div className={cx("modal_top")}></div>
            </div>
        </>
    );
};

export default Search;
